export default "__VITE_ASSET__07160b68__"